module.exports = __webpack_public_path__ + "static/media/person-with-desktop.d71416ea.png";